import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useTenantContext } from '../context/TenantContext';
import { useUserContext } from '../context/UserContext';
import ConfirmDialog from '../component-lib/ConfirmDialog/ConfirmDialog';
import { useState } from 'react';

export const VisibilityButton = ({ isLockActivated, isAdmin, row, handleTaskVisibility }) => {
  let isIconDisabled = false;

  // disable the button if the internal lock is activated, the task side is internal and the user is not admin
  if (isLockActivated && row.side === 'internal' && !isAdmin) {
    isIconDisabled = true;
  }

  return (
    <button
      className={isIconDisabled ? '' : 'cursor-pointer'}
      disabled={isIconDisabled}
      onClick={() => {
        handleTaskVisibility(row);
      }}
    >
      {row?.client_visible ? (
        <EyeIcon className={clsx('size-6', isIconDisabled ? 'text-gray-500' : 'text-green-500')} />
      ) : (
        <EyeSlashIcon
          className={clsx('size-6', isIconDisabled ? 'text-gray-500' : 'text-red-500')}
        />
      )}
    </button>
  );
};

export const VisibilityButtonWithMutation = ({
  cardId,
  clientVisible,
  side,
  disabled,
  toggleVisibilityMutation,
}) => {
  const { internal_lock_activated } = useTenantContext();
  const { user } = useUserContext();
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const hasAdminRole = user?.user_access_group?.some((role) => role.name === 'Admin');
  const isDisabled = internal_lock_activated && side === 'internal' && !hasAdminRole;

  return (
    <>
      <button
        disabled={disabled || isDisabled}
        onClick={() => {
          // Show confirm dialog if the card is internal, it's not visible and the user is not admin
          if (side === 'internal' && !clientVisible && !hasAdminRole) {
            setIsConfirmDialogOpen(true);
          } else {
            toggleVisibilityMutation.mutate({ cardId, visible: !clientVisible });
          }
        }}
        className="flex items-center"
      >
        {clientVisible ? (
          <EyeIcon className={clsx('size-6', isDisabled ? 'text-gray-500' : 'text-green-500')} />
        ) : (
          <EyeSlashIcon className={clsx('size-6', isDisabled ? 'text-gray-500' : 'text-red-500')} />
        )}
      </button>
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        setIsOpen={() => setIsConfirmDialogOpen(false)}
        title="Confirm Visibility Change"
        message="This task is internal. Are you sure you want to make it visible to external contacts?"
        onCancel={() => setIsConfirmDialogOpen(false)}
        onConfirm={() => {
          toggleVisibilityMutation.mutate({ cardId, visible: true });
          setIsConfirmDialogOpen(false);
        }}
        confirmText="Make visible"
        confirmTextProgress="Making visible..."
      />
    </>
  );
};
